import { render, staticRenderFns } from "./NotificationActivity.vue?vue&type=template&id=08a2509e&scoped=true&"
import script from "./NotificationActivity.vue?vue&type=script&lang=js&"
export * from "./NotificationActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a2509e",
  null
  
)

export default component.exports